/*!
 * Hire Job Description Template - Version: 2.1.15
 * Indeed - Copyright (c) 2020
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*
Parameters JS
 */
function regExpEscape(s) {
    return String(s).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').replace(/\x08/g, '\\x08');
}

function appendParamsOnce(url, params) {
    let useParams = params.replace(/^(\?|\&)/, '');
    if (url.match(new RegExp('[\\?|\\&]' + regExpEscape(useParams))) == null) {
        return url += (url.indexOf('?') > 0 ? '&' : '?') + useParams;
    }
    return url;
}

/**
 * Copy of Scripts-hire-dradis-seo.js (Used on JDP 1.0 pages)
 *
 */
$(document).ready(function(){
    if (!!$('#jobPostBtn').closest(".sections_jobdes").offset()) {
        $(window).scroll(function() {
            if(
                $(window).scrollTop() > ($('#jobPostBtn').closest(".sections_jobdes").offset().top + $('#jobPostBtn').closest(".sections_jobdes").height())
                && ($(window).scrollTop() + $(window).height() + 200) < $(document).height()
                && ($('.readyToHireSection').offset().top) > ($(window).scrollTop() + $(window).height() - 100)
                || ($('.readyToHireSection').offset().top + $('.readyToHireSection').height() - 200) < $(window).scrollTop() ) {
                $('.footer').addClass('show-footer-cta');
            }
            else {
                $('.footer').removeClass('show-footer-cta');
            }
        });
    }

    //Quick fix for post job button url and parameters.
    var pathname = window.location.pathname;
    var pagename = pathname.substring(pathname.lastIndexOf('/')+1);

    var postJobUrl = 'https://employers.indeed.com/p/post-job/?hl=en_US&co=US&isid=hire-seo-jobdescription-us-';

    $('.post-job-btn').attr('href',postJobUrl + 'mobile&ikw=' + pagename);


    $('.entry-content .wp-block-button__link').each(function() {
        var url = $(this).attr('href').replace('/ /g', '-');
        $(this).attr('href', url);
    });
});
//# sourceMappingURL=hire-job-description.js.map